// extracted by mini-css-extract-plugin
module.exports = {"section":"Tab_section__PEQYf"};